/*
*###############################################################################
*Module Name                   : DPTextBox.js                                  #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Dinisuru Balasuriya                          #
*Date                          : Tuesday, August 24th 2021, 1:47:16 pm         #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from 'react';
import { Row, Label, Input, Button } from "reactstrap"


const DPTextBoxTow = ({ rowClass, labelText, textType, value1, value2, onChange1, onChange2, placeholder1, placeholder2, textAlign, disabled1, disabled2, onKeyPress1, onKeyPress2, onBlur1, onBlur2, id, colWidth }) => {
    const colSize = colWidth ? colWidth : 3
    return (
        <Row className={rowClass}>
            <Label
                htmlFor="example-text-input"
                className={`col-md-${colSize} col-form-label-sm`}
            >
                {labelText}
            </Label>
            <div className={`col-md-3`}>
                <Input
                    className="form-control-sm"
                    type={textType}
                    value={value1}
                    onChange={onChange1}
                    onKeyPress={onKeyPress1}
                    onBlur={onBlur1}
                    onFocus={(e) => {
                        e.target.select()
                    }}
                    placeholder={placeholder1}
                    style={{ textAlign: textAlign ? textAlign : 'left' }}
                    disabled={disabled1}
                    id={id}
                />
            </div>
            <div className={`col-md-6`}>
                <Input
                    className="form-control-sm"
                    type={textType}
                    value={value2}
                    onChange={onChange2}
                    onKeyPress={onKeyPress2}
                    onBlur={onBlur2}
                    onFocus={(e) => {
                        e.target.select()
                    }}
                    placeholder={placeholder2}
                    style={{ textAlign: textAlign ? textAlign : 'left' }}
                    disabled={disabled2}
                    id={id}
                />
            </div>
        </Row>
    );
}

export default DPTextBoxTow;